import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { sortBy } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone, faPlus } from '@fortawesome/pro-solid-svg-icons';

import SmallerLoader from '../../SmallerLoader';
import PlugMeterGroup from './PlugMeterGroup';
import AddPlugMeterGroup from '../../modals/PlugCustomTemplateModals/AddPlugMeterGroup';
import ClonePlugMeterGroup from '../../modals/PlugCustomTemplateModals/ClonePlugMeterGroup';

const getStyles = (disabled) => {
  return {
    iconStyle: {
      fontSize: '21px',
      margin: '0.15em 0.25em 0em 0.25em',
      verticalAlign: 'text-bottom',
      cursor: disabled ? 'none' : 'pointer',
      color: 'var(--et_tab_grey)',
      opacity: disabled ? '0.5' : '1.0',
    },
  };
};

export default function PlugMeterGroups(props) {
  const {
    organizationId,
    allCredentials,
    meterGroups,
    setMeterGroups,
    showToast,
  } = props;

  const [activeMeterGroupId, setActiveMeterGroupId] = useState(null);
  const [activeMeterGroup, setActiveMeterGroup] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (activeMeterGroupId !== null) {
      let group = meterGroups.find(
        (group) => group.id === activeMeterGroupId
      );
      setActiveMeterGroup(group ? group : null);
    } else {
      setActiveMeterGroup(null);
    }
  }, [meterGroups, activeMeterGroupId]);

  return (
    <>
      <Row>
        <Col style={{ marginBottom: '0.5em' }} xs={12}>
          <Row style={{ padding: '1em 1em 0.5em 1em' }}>
            <Col style={{ display: 'inline-flex' }}>
              <Row>
                <Form inline style={{ marginBottom: '0.5em' }}>
                  <Form.Label
                    style={{
                      display: 'block',
                      marginRight: '0.5em',
                      marginLeft: '0.5em',
                    }}
                  >
                    Meter Group:
                  </Form.Label>
                  <Form.Control
                    style={{ float: 'right' }}
                    as='select'
                    size='sm'
                    value={activeMeterGroupId ? activeMeterGroupId : ''}
                    onChange={(e) => {
                      let tid = e.target.value;
                      setActiveMeterGroupId(parseInt(tid));
                      setActiveMeterGroup(null);
                    }}
                  >
                    <option hidden value={'null'} key={'null-opt'}>
                      Select a meter group
                    </option>
                    {meterGroups.length === 0 && (
                      <option disabled value={'dis'} key={'null-dis'}>
                        No Meter Groups
                      </option>
                    )}
                    {sortBy(meterGroups, ['name']).map((group) => (
                      <option
                        key={`group-opt-${group.id}-${group.group_type}`}
                        value={group.id}
                      >
                        {group.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form>
                <FontAwesomeIcon
                  style={getStyles(isSaving).iconStyle}
                  icon={faPlus}
                  title={'Add Meter Group'}
                  disabled={isSaving}
                  onClick={() => {
                    if (!isSaving) {
                      setShowAddModal(true);
                    }
                  }}
                />
                <FontAwesomeIcon
                  style={getStyles(isSaving).iconStyle}
                  icon={faClone}
                  title={'Clone Meter Group'}
                  disabled={isSaving}
                  onClick={() => {
                    if (!isSaving) {
                      setShowCloneModal(true);
                    }
                  }}
                />

                {isSaving && (
                  <div style={{ marginTop: '4px' }}>
                    <SmallerLoader style={{ fontSize: '18px' }} />
                  </div>
                )}
              </Row>
            </Col>
          </Row>
          <Row style={{ padding: '0em 2em' }}>
            {activeMeterGroupId !== null && activeMeterGroup !== null && (
              <PlugMeterGroup
                activeMeterGroup={activeMeterGroup}
                setMeterGroups={setMeterGroups}
                allCredentials={allCredentials}
                organizationId={organizationId}
                showToast={showToast}
                isSaving={isSaving}
                setIsSaving={setIsSaving}
              />
            )}
          </Row>
        </Col>
      </Row>
      <AddPlugMeterGroup
        show={showAddModal}
        onHide={() => {
          setShowAddModal(false);
        }}
        showToast={showToast}
        setMeterGroups={setMeterGroups}
        setActiveMeterGroupId={setActiveMeterGroupId}
        organizationId={organizationId}
      />
      <ClonePlugMeterGroup
        show={showCloneModal}
        onHide={() => {
          setShowCloneModal(false);
        }}
        showToast={showToast}
        meterGroups={meterGroups}
        setMeterGroups={setMeterGroups}
        setActiveMeterGroupId={setActiveMeterGroupId}
        organizationId={organizationId}
      />
    </>
  );
}
